import { render, staticRenderFns } from "./ReviewCardDoctor.vue?vue&type=template&id=2138ae03&"
import script from "./ReviewCardDoctor.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardDoctor.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2138ae03')) {
      api.createRecord('2138ae03', component.options)
    } else {
      api.reload('2138ae03', component.options)
    }
    module.hot.accept("./ReviewCardDoctor.vue?vue&type=template&id=2138ae03&", function () {
      api.rerender('2138ae03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardDoctor.vue"
export default component.exports